var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7158 5.58984C14.8301 5.49902 15 5.58398 15 5.72754V11.7188C15 12.4951 14.3701 13.125 13.5938 13.125H1.40625C0.629883 13.125 0 12.4951 0 11.7188V5.73047C0 5.58398 0.166992 5.50195 0.28418 5.59277C0.94043 6.10254 1.81055 6.75 4.79883 8.9209C5.41699 9.37207 6.45996 10.3213 7.5 10.3154C8.5459 10.3242 9.60938 9.35449 10.2041 8.9209C13.1924 6.75 14.0596 6.09961 14.7158 5.58984ZM7.5 9.375C8.17969 9.38672 9.1582 8.51953 9.65039 8.16211C13.5381 5.34082 13.834 5.09473 14.7305 4.3916C14.9004 4.25977 15 4.05469 15 3.83789V3.28125C15 2.50488 14.3701 1.875 13.5938 1.875H1.40625C0.629883 1.875 0 2.50488 0 3.28125V3.83789C0 4.05469 0.0996094 4.25684 0.269531 4.3916C1.16602 5.0918 1.46191 5.34082 5.34961 8.16211C5.8418 8.51953 6.82031 9.38672 7.5 9.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.39494e38d7417299acfbcd04249e802f.svg";
export { ForwardRef as ReactComponent };